(ns shared.core.components.dropdown
  (:require [shared.core.reactive :as re]
            [shared.core.components.icon :as icon]
            [shared.core.components.input :as input]
            [shared.core.components.label :as lbl]
            [shared.core.components.pill :refer [pill]]
            [shared.core.style :as style]
            ["semantic-ui-react" :as semantic-ui]
            [shared.core.util :as util]
            [clojure.string :as s]))

;; https://react.semantic-ui.com/modules/dropdown/

(style/add-css [".novo-dropdown.ui.search" (merge input/base-style
                                                  input/input-style
                                                  {:font-size "14px"
                                                   :padding "5px 25px 5px 8px"
                                                   :min-height :auto})]
               [".novo-dropdown.ui.selection.dropdown>.dropdown.icon.clear"
                {:margin-top "2px"}]
               [".novo-dropdown.ui.dropdown>.dropdown.icon.clear:before"
                {:content "'close'"
                 :font-family style/material-icons-font-family
                 :color (style/color :gray :base)
                 :text-transform :none
                 :font-size "12px"}]
               [".novo-dropdown.ui.search.primary" (merge input/primary-base-style
                                                          {:height "32px"})]
               [".novo-dropdown.ui.search.primary.selection.dropdown:not(.multiple)>.text" {:font-size "12px"}]
               [".novo-dropdown.ui.search.primary" {:background-color "#fff"
                                                    :border-color "rgba(0, 0, 0, 0.4)"}]
               [".novo-dropdown.ui.search.primary:hover" {:border-color "rgba(0, 0, 0, 0.4)"}]
               [".novo-dropdown.ui.primary.selection.dropdown>.dropdown.icon" {:padding "3px"}]
               [".novo-dropdown.ui.search.primary.multiple" {:height "auto"}]
               [".novo-dropdown.ui.search.dark" (merge (get input/theme-base-style :dark)
                                                       (get input/theme-input-style :dark))]
               [".novo-dropdown.ui.search.multiple" {:padding "7px 25px 7px 8px"}]
               [".novo-dropdown.ui.search.active, .novo-dropdown.ui.search.active:hover, .novo-dropdown.ui.search.active .menu, .novo-dropdown.ui.search.active:hover .menu"
                input/input-focus-style]
               [".novo-dropdown.ui.search.primary.active, .novo-dropdown.ui.search.primary.active:hover, .novo-dropdown.ui.search.primary.active .menu, .novo-dropdown.ui.search.primary.active:hover .menu"
                input/primary-input-focus-style]
               [".novo-dropdown.ui.search.dark.active, .novo-dropdown.ui.search.dark.active:hover, .novo-dropdown.ui.search.dark.active .menu, .novo-dropdown.ui.search.dark.active:hover .menu"
                (get input/theme-input-focus-style :dark)]
               ["button, input, optgroup, select, textarea" {:font-family style/font-family}]
               [".ui.buttons>div>.ui.dropdown:last-child .menu"
                {:left :auto
                 :right 0}]
               [".novo-dropdown.ui.search.selection.dropdown:not(.multiple)>.text" {:line-height 1.3
                                                                                    :text-overflow "ellipsis"
                                                                                    :white-space "nowrap"
                                                                                    :overflow "hidden"
                                                                                    :padding-top "1px"
                                                                                    :max-width "100%"}]
               [".novo-dropdown.ui.search.selection.multiple.dropdown>.text" {:padding-top "1px"
                                                                              :padding-left "1px"}]
               [".novo-dropdown.ui.search.multiple" {:padding "1px 30px 1px 6px"}]
               [".novo-dropdown.ui.search.selection.dropdown>input.search" {:padding "7px 20px 7px 8px"}]
               [".novo-dropdown.ui.search.selection.multiple.dropdown>input.search" {:margin-left "2px"
                                                                                     :padding "0"}]
               [".novo-dropdown.ui.dropdown .menu>.item, .novo-dropdown.ui.dropdown .menu>.message"
                {:font-size "14px"
                 :padding "7px 8px !important"}]
               [".novo-dropdown.ui.dropdown .menu .active.item" {:font-weight style/font-regular-weight}]
               [".novo-dropdown.ui.dropdown.max-results .menu.visible" {:padding-bottom "20px"}]
               [".novo-dropdown.ui.dropdown.max-results .menu.visible:after" {:content "\"Type to Search\""
                                                                              :background-color (style/color :gray :shade-7)
                                                                              :color (style/color :gray :base)
                                                                              :font-size "11px"
                                                                              :font-weight style/font-medium-weight
                                                                              :text-align :center
                                                                              :display "flex"
                                                                              :align-items "center"
                                                                              :justify-content "center"
                                                                              :position "absolute"
                                                                              :bottom "0"
                                                                              :left "0"
                                                                              :height "20px"
                                                                              :width "100%"}]
               [".novo-dropdown.ui.dropdown>.label" {:border-radius "3px"
                                                     :box-shadow "none"
                                                     :font-weight style/font-medium-weight
                                                     :padding ".35714286em .48571429em"}]
               [".novo-dropdown.ui.dropdown.primary.multiple>.label" {:color (style/color :on-background :base)}]
               [".novo-dropdown.ui.floating.dropdown>.menu" {:border-radius "3px !important"}]
               [".novo-dropdown.ui.selection.dropdown>.dropdown.icon" {:margin "0"
                                                                       :padding "7px"
                                                                       :top "50%"
                                                                       :right "2px"
                                                                       :transform "translateY(-50%)"}]
               [".novo-dropdown i.icon.delete" {:font-family "'Material Icons'"
                                                :margin-left "0.3em"
                                                :vertical-align :bottom}]
               [".ui.novo-dropdown.default.dropdown:not(.button)>.text, .ui.dropdown:not(.button)>.default.text"
                {:color (util/hex->rgba (style/color :gray :base) 0.3)}]
               [".novo-dropdown i.icon.delete:before" {:content "\"close\""}]
               [".ui.novo-dropdown.dropdown>.dropdown.icon.clear:before" {:color (style/color :gray :base)}]

               ;; dark theme
               [".ui.active.search.dropdown.dark input.search:focus+.text"
                {:color (str (util/hex->rgba (style/dark-color :on-background :base) 0.9) " !important")}]
               [".ui.search.dropdown.dark input.search+.default.text, .ui.active.search.dropdown.dark input.search:focus+.default.text"
                {:color (str (util/hex->rgba (style/dark-color :on-background :base) 0.7) " !important")}]
               [".ui.search.dropdown.dark a.label, .ui.search.dropdown.dark i.delete"
                {:color (str (style/color :gray :base) " !important")
                 :background (str (util/hex->rgba (style/dark-color :on-background :base) 0.9) " !important")}]
               [".ui.dropdown.dark .menu>.item"
                {:background (style/dark-color :background :base)
                 :border-top "1px solid transparent"}]
               [".ui.dropdown.dark .menu .item:hover"
                {:background (style/dark-color :surface :base)}]
               [".ui.dropdown.dark .menu .selected.item, .ui.dropdown.selected.dark, .ui.link.menu.dark .item:active, .ui.menu.dark .link.item:active, .ui.menu.dark a.item:active"
                {:background (util/hex->rgba (style/dark-color :surface :base) 0.8)}])

(defn dropdown [{:keys [val-subscribe form-path form-name]}]
  (let [val- (if val-subscribe
               (re/subscribe val-subscribe)
               (when (and form-path form-name)
                 (re/subscribe [:form/val- form-path form-name])))
        theme- (re/subscribe [:core/theme-])]
    (fn [{:keys [options form-path form-name search? fluid? selection? placeholder style label container-style required?
                 search-input multiple? select-on-blur? clearable? force-store-in-vec? default-value search
                 search-query on-change on-label-click on-search-change value no-results-message extra-on-change
                 sort-by-text? select-on-navigation? disabled? floating? class-name trigger label-info on-click open?
                 on-open on-close on-focus on-blur lazy-load? min-characters max-results key? close-on-escape?
                 skip-search-filter? extra-on-search allow-additions? on-add-item render-label label-cmp upward?
                 label-class-name pre-phosphor-icon pre-material-icon pre-icon-style label-offset id text close-on-blur?
                 close-on-change? auto-focus?]
          :or {close-on-escape? true
               search? true
               fluid? true
               selection? true
               select-on-blur? false
               select-on-navigation? false
               clearable? false
               sort-by-text? false
               search-input :search
               key? true}}]
      (let [label-offset (or label-offset 8)
            loading? (= options :loading)
            options (if (or (= options :loading) (not options))
                      []
                      (->> (distinct options)
                           (filterv identity)
                           (mapv (fn [{:keys [text tags] :as o}]
                                   (let [text (if tags
                                                [:div {:style {:display :flex
                                                               :flex-direction :column}}
                                                 [:span text]
                                                 (into [:div {:style {:display :flex
                                                                      :flex-wrap :wrap
                                                                      :margin-top 3}}]
                                                       (map (fn [t]
                                                              [pill {:style {:margin "0 3px 3px 0"}}
                                                               t])
                                                            tags))]
                                                text)]
                                     (assoc
                                       (if (vector? text)
                                         (assoc o :text (re/as-element text))
                                         o)
                                       :search (or (:search o)
                                                   (if (vector? text)
                                                     (s/join " " (filter string?
                                                                         (flatten text)))
                                                     text))))))))
            in-value value
            value (or value
                      (when val-
                        (some->> (if (coll? @val-)
                                   @val-
                                   [@val-])
                                 (map (fn [v]
                                        (->> options
                                             (filter #(= (:value %) v))
                                             (first))))
                                 (filterv identity))))
            value-to-use (cond
                           (and (vector? value) (not multiple?))
                           (:value (first value))

                           (and (vector? value) multiple?)
                           (map #(if (map? %) (:value %) %) value)

                           :else
                           value)
            ids-contain-search? (fn [ids search]
                                  (and ids
                                       (not-empty search)
                                       (or (contains? ids search)
                                           (contains? ids (util/parse-int search)))))
            sem-options (->> options
                             (#(if max-results
                                 (let [results (take max-results %)]
                                   (if (not (some (fn [r] (= (:value r) value-to-use)) results))
                                     (concat (take (dec max-results) results)
                                             [(some->> options
                                                       (filter (fn [o]
                                                                 (= (:value o) value-to-use)))
                                                       (first))])
                                     results))
                                 %))
                             (mapv (fn [{:keys [result-transf] :as r}]
                                     (util/->camelCaseKeywords (dissoc (if result-transf (result-transf r) r)
                                                                       :result-transf :ids-to-match))))
                             (filterv identity))
            search-input-config (cond-> {}
                                        auto-focus?
                                        (assoc :auto-focus true))
            semantic-args (cond-> {:class-name (s/join " "
                                                       (filter identity ["novo-dropdown"
                                                                         (when value-to-use "with-value")
                                                                         (when max-results "max-results")
                                                                         (when (or pre-phosphor-icon pre-material-icon)
                                                                           "pre-icon")
                                                                         (when @theme- (name @theme-))
                                                                         class-name]))
                                   :options (if sort-by-text? (sort-by :text sem-options) sem-options)
                                   :style style
                                   :search-input search-input-config
                                   :search (when-not floating?
                                             (or search
                                                 (fn [_ search-text]
                                                   (when extra-on-search (extra-on-search search-text))
                                                   (some->> options
                                                            (filterv
                                                              (fn [{:keys [ids-to-match] :as o}]
                                                                (if skip-search-filter?
                                                                  true
                                                                  (let [o-search (some-> o
                                                                                         (get search-input)
                                                                                         (s/lower-case))]
                                                                    (or (ids-contain-search? ids-to-match search-text)
                                                                        (and (some-> o-search
                                                                                     (s/includes? (some-> search-text
                                                                                                          (s/lower-case))))
                                                                             (or (not in-value)
                                                                                 (not (some #(= (some-> %
                                                                                                        (str)
                                                                                                        (s/lower-case))
                                                                                                o-search)
                                                                                            (str in-value))))))))))
                                                            (#(if max-results (take max-results %) %))
                                                            (mapv (fn [{:keys [result-transf] :as r}]
                                                                    (dissoc (if result-transf (result-transf r) r)
                                                                            :result-transf)))
                                                            (sort (fn [a b]
                                                                    (let [a-id-match? (ids-contain-search?
                                                                                        (:ids-to-match a)
                                                                                        search-text)
                                                                          b-id-match? (ids-contain-search?
                                                                                        (:ids-to-match b)
                                                                                        search-text)
                                                                          a-text (:text a)
                                                                          b-text (:text b)]
                                                                      (cond
                                                                        (and a-id-match? (not b-id-match?))
                                                                        -1

                                                                        (and (not a-id-match?) b-id-match?)
                                                                        1

                                                                        sort-by-text?
                                                                        (compare a-text b-text)


                                                                        :else
                                                                        0))))
                                                            (clj->js)))))
                                   :fluid (and fluid? (not floating?))
                                   :selection (and selection? (not floating?))
                                   :multiple multiple?
                                   :select-on-blur select-on-blur?
                                   :select-on-navigation select-on-navigation?
                                   :clearable clearable?
                                   :on-focus #(do
                                                (re/dispatch [:keybind/pause-current-route-bindings])
                                                (when on-focus (on-focus %)))
                                   :on-blur #(do
                                               (re/dispatch [:keybind/resume-current-route-bindings])
                                               (when on-blur (on-blur %)))
                                   :on-change (or on-change
                                                  (fn [_ d]
                                                    (let [v (aget d "value")]
                                                      (when (and form-path form-name)
                                                        (if (and (not multiple?)
                                                                 (not force-store-in-vec?))
                                                          (re/dispatch [:form/change
                                                                        form-path
                                                                        form-name
                                                                        v])
                                                          (let [clj-v (js->clj v)]
                                                            (when-not multiple?
                                                              (re/dispatch [:form/change-remove-from-vec
                                                                            form-path
                                                                            form-name
                                                                            (mapv :value options)]))
                                                            (if (some-> clj-v (vector?))
                                                              (re/dispatch [:form/change
                                                                            form-path
                                                                            form-name
                                                                            (distinct (map #(if (map? %)
                                                                                              (get % "value")
                                                                                              %)
                                                                                           clj-v))])
                                                              (re/dispatch [:form/change-add-to-vec
                                                                            form-path
                                                                            form-name
                                                                            clj-v])))))
                                                      (when extra-on-change
                                                        (extra-on-change v)))))}
                                  id (assoc :id id)
                                  on-click (assoc :on-click on-click)
                                  on-open (assoc :on-open on-open)
                                  on-close (assoc :on-close on-close)
                                  placeholder (assoc :placeholder placeholder)
                                  no-results-message (assoc :no-results-message no-results-message)
                                  search-query (assoc :search-query search-query)
                                  on-search-change (assoc :on-search-change on-search-change)
                                  on-label-click (assoc :on-label-click on-label-click)
                                  (or value-to-use (false? value-to-use)) (assoc :value value-to-use)

                                  (and (or default-value
                                           (and val- @val-))
                                       (not (or value-to-use (false? value-to-use))))
                                  (assoc :default-value (or default-value (and val- @val-)))

                                  trigger (assoc :trigger trigger)
                                  text (assoc :text text)
                                  (not (nil? upward?)) (assoc :upward upward?)
                                  disabled? (assoc :disabled true)
                                  floating? (assoc :floating true)
                                  min-characters (assoc :min-characters min-characters)
                                  open? (assoc :open true)
                                  (not (nil? close-on-blur?)) (assoc :close-on-blur close-on-blur?)
                                  (not (nil? close-on-change?)) (assoc :close-on-change close-on-change?)
                                  (not (nil? close-on-escape?)) (assoc :close-on-escape close-on-escape?)
                                  loading? (assoc :loading true
                                                  :open false)
                                  lazy-load? (assoc :lazy-load true)
                                  allow-additions? (assoc :allow-additions allow-additions?)
                                  on-add-item (assoc :on-add-item on-add-item)
                                  render-label (assoc :render-label render-label))]
        [:div (cond-> {:style (merge {:display :flex
                                      :flex-direction :column
                                      :position :relative}
                                     container-style)}
                      key? (assoc :key (pr-str semantic-args)))
         (when label
           (into [(or label-cmp lbl/label) {:class-name label-class-name
                                            :required? required?
                                            :info-tooltip label-info}]
                 [label]))
         (if pre-phosphor-icon
           [icon/phosphor-icon {:icon-type pre-phosphor-icon
                                :style (merge {:color (or (:color style) (style/color :gray :shade-16))
                                               :cursor :pointer
                                               :font-size 24
                                               :position :absolute
                                               :top (if label
                                                      (str "calc(50% + " label-offset "px)")
                                                      "50%")
                                               :left 12
                                               :transform "translateY(-50%)"
                                               :z-index (+ (style/z :medium) 2)}
                                              pre-icon-style)}]
           (when pre-material-icon
             [icon/material-icon {:icon-type pre-material-icon
                                  :style (merge {:color (or (:color style) (style/color :gray :shade-16))
                                                 :cursor :pointer
                                                 :font-size 24
                                                 :position :absolute
                                                 :top (if label
                                                        (str "calc(50% + " label-offset "px)")
                                                        "50%")
                                                 :left 12
                                                 :transform "translateY(-50%)"
                                                 :z-index (+ (style/z :medium) 2)}
                                                pre-icon-style)}]))
         [:> semantic-ui/Dropdown semantic-args]]))))

(defn primary-dropdown [args]
  (let [class-name (:class-name args)
        combined-class-name (s/join " " (filter identity [class-name "primary"]))]
    [dropdown (assoc args :class-name combined-class-name
                          :label-cmp lbl/primary-label)]))
